<template>
  <!-- Layout inner -->
  <div class="layout-inner dashbaord career_skill">
    <!-- Layout navbar -->
    <navbar></navbar>
    <!-- / Layout navbar -->
    <div class="layout-container">
      <div class="layout-content">

        <div class="hd_bar">
          <div class="hd_ic">
            <span class="ic-summary"></span>
          </div>
          <div class="hd_txt">
            <span class="title_txt" id="userName">{{userCareerSummary}}</span>

            <b-popover ref="userNamePopupContainer" target="userName" triggers="click" placement="top" class="title_popup" container="userNameContainer">
              <div class="title_container">
                {{userCareerSummary}}
              </div>
              <div class="ic_container">
                <span class="ic ic-close" v-on:click="hideUserNamePopup"></span>
              </div>
            </b-popover>
            <div id="userNameContainer" class="title_container_popup"></div>

          </div>
        </div>

        <!-- Page content -->
        <div class="container-fluid flex-grow-1 pg_content_container">

          <template v-if="isCareerProgressAvailable">
            <b-tabs v-model="tabIndex">

              <b-tab no-body title="Skill Progress" :title-link-class="linkClass(0)" title-item-class="w-50 text-center">

                <div class="row" style="margin-left: 5px; margin-right: 5px;">
                  <div class="col-12">

                    <div class="row pg_content_col legends" v-if="isSkillProgessGenerated">
                      <div class="status_row col-6"><span class="lg_blc gc_completed"></span> Completed</div>
                      <div class="status_row col-6"><span class="lg_blc gc_in_progress"></span> In Progress</div>
                      <div class="status_row col-6"><span class="lg_blc gc_in_plan"></span> In the Plan</div>
                      <div class="status_row col-6"><span class="lg_blc gc_missing"></span>  Missing</div>
                    </div>

                    <div class="row mt-4">
                      <div class="col-12">
                        <div class="row d-flex flex-wrap align-items-center">
                          <template v-for="(values, key, index) in typeAndProgressMap">
                            <div v-if="key !== 'TOTAL'" class="col-xl-6 col-sm-6 col-6" style="max-width: 50%; text-align: center;">
                              <div :id="'skillPieChart_' + index"></div>
                              <div style="margin-top: 12px; margin-bottom: 30px;">{{careerTypesMap[key]}}</div>
                            </div>
                          </template>
                          <template  v-if="!isSkillProgessGenerated" class="w-100">
                            <spinner size="large"></spinner>
                          </template>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </b-tab>

              <b-tab no-body title="Skill Breakup" :title-link-class="linkClass(1)" title-item-class="w-50 text-center" class="tab_content_sec skill_breakup">
                <div class="row">
                  <div class="col-sm-3 col-xl-3">

                    <div class="row pg_content_col legends">
                      <template v-for="(values, key, index) in typeAndProgressMap">
                        <div v-if="key !== 'TOTAL'" class="status_row col-3">
                          <span class="lg_blc " :style="{background: skillTypeColorMap[key]}"></span>
                          {{careerTypesMap[key]}}
                        </div>
                      </template>
                    </div>

                    <div v-for="(skills, label, i) in typeStatusAndTagMap">

                      <div class="accordion acc_sec">
                        <div class="head" role="heading" v-b-toggle="'collapse-' + i" variant="primary">
                          <div class="tag-type-status" :style="{background: skillStatusColorMap[label]}">
                              <div class="ic_container">
                                <span class="ic ic-add_circle"></span>
                                <span class="ic ic-remove_circle"></span>
                              </div>
                              <div>{{label}}</div>
                          </div>
                        </div>
                        <b-collapse :id="'collapse-' + i" class="acc_content">
                          <template v-if="skills.length > 0">

                            <template v-for="(skill, j) in skills">
                              <div class="content_row">

                                <div class="tag" :class="skill.type" :id="skill.competencyId" style="cursor: pointer;" @click="openProgressPopup(skill.competencyId)">
                                    <span class="competency-tag">{{skill.title}}</span>
                                    <span class="tag-label" v-if="skill.level">
                                        <span>{{skill.level}}</span>
                                    </span>
                                    <!--
                                    <span class="tag-label" v-else>
                                        <span>-</span>
                                    </span>
                                    -->
                                </div>

                                <div id="skillsTagsPopover"></div>
                                <b-popover :ref="'progressPopup_' + skill.competencyId" :target="skill.competencyId" triggers="click" placement="top" container="skillsTagsPopover">
                                  <div slot="title">
                                    <span>{{skill.title}}</span>
                                    <b-button class="btn_close" @click="closeProgressPopup(skill.competencyId)">
                                      <span class="ic-close"></span>
                                    </b-button>
                                  </div>
                                  <div>
                                    <div>Courses</div>
                                    <div v-if="skill.skillFulfillments.length > 0">
                                      <div>
                                        <div class="tag" v-for="(fulFillment, index) in skill.skillFulfillments">
                                          <span class="tag_name" style="color: #fff; width: 100%; max-width: 343px;" :title="fulFillment.entityTitle" :style="{background: skillStatusColorMap[skillStatusMap['' + fulFillment.status]]}">{{fulFillment.entityTitle}}</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div v-else>
                                      <span>No Courses</span>
                                    </div>
                                  </div>
                                </b-popover>

                              </div>
                            </template>

                          </template>
                        </b-collapse>
                      </div>

                      <div v-if="skills.length > 0" class="course_skill_breakup">

                        <!--
                        <div class="tag-type-head" role="heading" style="float: left; width: 100%; margin-bottom: 1px;">
                          <div class="tag-type-status" :style="{background: skillStatusColorMap[label]}">
                              <div class="tag-type-status-circle mr-2 float-left">
                                  <span>-</span>
                              </div>
                              <div>{{label}}</div>
                          </div>
                        </div>
                        -->

                        <div class="">

                        </div>
                      </div>


                    </div>
                  </div>
                </div>
              </b-tab>

            </b-tabs>
          </template>

        </div>
        <!-- Footer Navbar -->
        <stream-footer-navbar :uuid="uuid"></stream-footer-navbar>
        <!-- / Footer Navbar -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import Navbar from '../../misc/components/./Navbar'
import StreamFooterNavbar from '../../misc/components/./StreamFooterNavbar'
import VClamp from 'vue-clamp'
import * as d3 from 'd3'

export default {
  name: 'streamCareer',
  props: ['uuid'],
  components: {
    Navbar,
    StreamFooterNavbar,
    VClamp
  },
  data: () => {
    return {
      tabIndex: 0,
      careerTypesMap: {
        'HARD': 'Hard Skills',
        'SOFT': 'Soft Skills',
        'CERTIFICATION': 'Certifications',
        'SKILL': 'Skills',
        'ABILITY': 'Abilities',
        'KNOWLEDGE': 'Knowledge',
        'TOTAL': 'Overall'
      },
      skillTypeColorMap: {
        'HARD': '#ed8b05',
        'SOFT': '#e91e63',
        'CERTIFICATION': '#9c27b0',
        'SKILL': '#8d5202',
        'ABILITY': '#d782ff',
        'KNOWLEDGE': '#5bb2f5',
        'TOTAL': '#454545'
      },
      skillProgressLabelMap: {
        'completed': 'Completed',
        'inProgress': 'In Progress',
        'planned': 'In the Plan',
        'missing': 'Missing'
      },
      typeAndProgressMap: {},
      skillStatusMap: {
        '2': 'Completed',
        '1': 'In Progress',
        '0': 'In the Plan',
        '-1': 'Missing'
      },
      skillStatusColorMap: {
        'Completed': '#528016',
        'In Progress': '#a1c75f',
        'In the Plan': '#eb8807',
        'Missing': '#e0291f'
      },
      typeStatusAndTagMap: {},
      isSkillProgessGenerated: false
    }
  },

  mounted () {
    this.loadStream()
  },

  updated () {
    this.$nextTick(() => {
      let keys = Object.keys(this.typeAndProgressMap)
      if (keys.length > 0) {
        keys.forEach((key, i) => {
          let data = this.typeAndProgressMap[key]
          let circleColor = this.skillTypeColorMap[key]
          this.generateDonutChart(data, circleColor, 'skillPieChart_' + i)
          this.isSkillProgessGenerated = true
        })
      }
    })
  },

  methods: {
    ...mapActions([
      'loadStreamDetail'
    ]),
    linkClass (idx) {
      if (this.tabIndex === idx) {
        return ['active']
      } else {
        return ['bg-primary', 'text-light']
      }
    },
    async loadStream () {
      this.steam = await this.loadStreamDetail(this.uuid)
      if (this.stream.careerProgress) {
        if (this.stream.careerProgress.progressByTypeMap) {
          this.typeAndProgressMap = {}
          let types = Object.keys(this.stream.careerProgress.progressByTypeMap)
          types.forEach(type => {
            if (type !== 'EXTRA') {
              let progress = this.stream.careerProgress.progressByTypeMap[type]
              if (progress) {
                let data = []
                let keys = Object.keys(progress)
                keys.forEach(key => {
                  let value = progress[key]
                  let label = this.skillProgressLabelMap[key]
                  if (label && value > 0) {
                    data.push({label: label, value: value})
                  }
                })
                this.typeAndProgressMap[type] = data
              }
            }
          })
        }

        if (this.stream.careerProgress.careerSkills && this.stream.careerProgress.careerSkills.length > 0) {
          let statusMap = {}
          let careerSkills = this.stream.careerProgress.careerSkills
          careerSkills.forEach(careerSkill => {
            let status = '' + ((careerSkill.status >= 2) ? 2 : careerSkill.status)
            let keys = Object.keys(statusMap)
            if (keys.includes(status)) {
              statusMap[status].push(careerSkill)
            } else {
              let skills = [careerSkill]
              this.$set(statusMap, status, skills)
            }
          })

          this.typeStatusAndTagMap = {}
          let keys = Object.keys(statusMap)
          if (keys.length > 0) {
            keys.sort().reverse().forEach(key => {
              let label = this.skillStatusMap[key]
              this.$set(this.typeStatusAndTagMap, label, statusMap[key])
            })
          }
        }
      }
    },
    generateDonutChart (data, circleColor, elementId) {
      $('#' + elementId).empty()
      let pieChartContainerHeight = 162
      let pieChartInnerRadius = 35
      let width = pieChartContainerHeight
      let height = pieChartContainerHeight
      let radius = pieChartContainerHeight / 2

      let colorScale = this.skillStatusColorMap

      let tooltip = d3.select('body')
                    .append('div')
                    .style('position', 'absolute')
                    .style('z-index', '10')
                    .style('visibility', 'hidden')
                    .style('color', '#111')
                    .attr('class', 'report-tooltip-xaxis')
                    .style('padding', '8px')
                    .style('border-radius', '6px')
                    .style('font', 'bold 15px Arial')
                    .text('tooltip')

      let canvas = d3.select('#' + elementId).append('svg')
                   .data([data]).attr('width', width).attr('height', height).append('g')
                   .attr('transform', 'translate(' + radius + ',' + radius + ')')

      let circleRadius = radius / 2
      canvas.append('svg:circle')
            .attr('r', circleRadius * 0.6)
            .style('fill', circleColor)

      let arc = d3.arc()
                .outerRadius(radius)
                .innerRadius(pieChartInnerRadius)

      let pie = d3.pie()
                .value(function (d) { return d.value }).sort(null)

      let arcs = canvas.selectAll('.arc')
                 .data(pie(data))
                 .enter().append('g')
                 .attr('class', 'arc')

      arcs.append('path')
          .attr('d', arc)
          .style('fill', function (d, i) { return colorScale[d.data.label] })
          .on('mouseover', function (d) {
            tooltip.text(d.data.label + ': ' + d.data.value + (''))
            tooltip.style('visibility', 'visible')
          })
          .on('mousemove', function () {
            return tooltip.style('top', (d3.event.pageY - 25) + 'px').style('left', (($(window).width() - 150) > d3.event.pageX ? (d3.event.pageX + 10) : (d3.event.pageX - 130)) + 'px')
          })
          .on('mouseout', function () {
            return tooltip.style('visibility', 'hidden')
          })

      arcs.append('text')
          .attr('transform', function (d) { return 'translate(' + arc.centroid(d) + ')' })
          .style('font', 'bold 12px Arial')
          .style('fill', '#fff')
          .style('cursor', 'default')
          .attr('text-anchor', 'middle')
          .text(function (d) { return d.data.value })
          .on('mouseover', function (d) {
            tooltip.text(d.data.label + ': ' + d.data.value + (''))
            tooltip.style('visibility', 'visible')
          })
          .on('mousemove', function () {
            return tooltip.style('top', (d3.event.pageY - 25) + 'px').style('left', (($(window).width() - 150) > d3.event.pageX ? (d3.event.pageX + 10) : (d3.event.pageX - 130)) + 'px')
          })
          .on('mouseout', function () {
            return tooltip.style('visibility', 'hidden')
          })
    },

    openProgressPopup (competencyId) {
      let ref = 'progressPopup_' + competencyId
      this.$root.$emit('bv::hide::popover')
      this.$refs[ref][0].$emit('open')
    },

    closeProgressPopup (competencyId) {
      let ref = 'progressPopup_' + competencyId
      this.$refs[ref][0].$emit('close')
    },

    hideUserNamePopup () {
      this.$refs.userNamePopupContainer.$emit('close')
    }

  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'stream': state => state.stream.stream,
      'enabledFeatures': state => state.dashboard.enabledFeatures
    }),
    userCareerSummary () {
      if (this.userObj) {
        return this.userObj.firstName + '\'s ' + this.userObj.careerGoal + ' Career'
      } else {
        return ''
      }
    },
    isCareerProgressAvailable () {
      if (this.stream && this.stream.careerProgress && this.stream.careerProgress.progressByTypeMap) {
        let keys = Object.keys(this.stream.careerProgress.progressByTypeMap)
        if (keys && keys.length > 1) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    showSkillLevel () {
      let skillTaggingFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SKILL_TAGGING_FEATURE_ID]
      if (skillTaggingFeature) {
        let flags = skillTaggingFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if ((flags[i].title === 'sourceEMSI') && flags[i].enabled) {
            return false
          }
        }
      }
      return true
    }
  }
}
</script>

<style scoped>
  .status_row {
    display: flex;
    align-items: center;
    height: 33px;
    margin: 6px 0;
    min-width: 130px;
    font-size: 15px;
  }

  .lg_blc {
    width: 20px;
    height: 20px;
    display: inline-block;
    margin: 0 12px 0 0;
  }

  .gc_completed {
    background: #528016;
  }

  .gc_in_progress {
    background: #a1c75f;
  }

  .gc_in_plan {
    background: #eb8807;
  }

  .gc_missing {
    background: #e0291f;
  }

  .tag-type-head {
    width: 25%;
    margin-bottom: 12px;
    min-width: 325px;
  }

  .tag-type-status {
    padding: 15px 0px 15px 20px;
    font-size: 18px;
    font-weight: 800;
    color: #ffffff;
  }

  .tag-type-status-circle {
    height: 25px;
    width: 25px;
    border-radius: 50%;
    display: inline-block;
    border: 3px solid #fff;
    line-height: 16px;
    text-align: center;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .tag {
    display: flex;
    margin: 1px 11px 0 1px;
    border: 1px solid #b3b3b3;
    border-radius: 3px;
    padding: 0;
    margin-bottom: 10px;
    color: #303030;
  }

  .tag-label {
    padding: 6px 0;
    font-weight: 800;
    width: 26px;
    text-align: center;
    color: #fff;
    border-left: 1px solid #b3b3b3;
  }

  .HARD .tag-label {
    background-color: #ed8b05;
  }

  .SOFT .tag-label {
    background-color: #e91e63;
  }

  .CERTIFICATION .tag-label {
    background-color: #9c27b0;
  }

  .SKILL .tag-label {
    background-color: #8d5202;
  }

  .ABILITY .tag-label {
    background-color: #d782ff;
  }

  .KNOWLEDGE .tag-label {
    background-color: #5bb2f5;
  }

  .competency-tag {
    width: 200px;
    padding: 5px 5px 8px 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-color: #e1e1e1;
  }
</style>



// WEBPACK FOOTER //
// src/app/stream/components/StreamCareer.vue